import { Select } from "antd";
import React, { useCallback, useMemo } from 'react';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import { useSelector } from "../../../../../util/store/store";
import { cloneObj, filterOption, renderOpts } from "../../../../../util/varibles/global";
import { ISite, ITaskService, TOperation } from "../../../../../util/varibles/interface";
import { UnitModel } from "../../../BiologyBrowser/constants";
import { selectPlan } from "../../../constants";
import { IUnitWhenEdit, setEditOp, useEditOp } from "../EditOperationContext";
import { initTask } from "./constants";
import styles from './style.module.scss';
import Task from "./Task";

const Title: React.FC<{ id: string, name: string, count: number }> = ({ id, name, count }) => {
    const sites = useSelector(selectPlan.sites);
    const set = setEditOp();
    const handleAddTask = () => {
        set(({ operation }) => {
            if (operation) {
                const tasks = cloneObj(operation.tasks || []) as ITaskService[];
                tasks.splice(count, 0, initTask({ location_id: id, location_name: name }));
                return {
                    operation: { ...operation, tasks } as TOperation
                }
            }
            return {}
        })
    }

    return <div className={styles.task} data-lev='title'>
        <div>
            <Select
                className="min-w-[150px]"
                variant="borderless"
                value={id?.length > 0 ? id : null}
                placeholder="Select location"
                showSearch={{
                    filterOption
                }}
                popupMatchSelectWidth={false}
                onChange={(_, opt) => {
                    if (!opt || Array.isArray(opt)) return;
                    const { root } = opt
                    set(({ operation }) => {
                        if (!operation) return {};

                        const tasks: ITaskService[] = cloneObj(operation.tasks || []);
                        const { units } = root
                        return {
                            site: root as ISite,
                            operation: {
                                ...operation,
                                tasks: tasks.map(item => ({
                                    ...item,
                                    location_id: root.id,
                                    location_name: root.name,
                                    sub_operations: [],
                                }) as ITaskService)
                            } as TOperation,
                            isCalculate: true,
                            units: units.reduce((rs: { [id: string]: IUnitWhenEdit }, item) => {
                                const { id } = item;
                                rs[id] = UnitModel(item, root);
                                return rs;
                            }, {}),
                        };
                    })
                }}
                options={renderOpts<ISite>(sites)}
            />
        </div>
        <div className='pl-2'>Units</div>
        <div className='pl-3'>Task</div>
        <div>In duration</div>
        <div />
        <div className="flex justify-end">
            <div className='bt-ghost w-[32px]' data-icon={true} title='Add task' onClick={() => handleAddTask()}>
                <Icon icon={ICON_NAME.ADD_2} />
            </div>
        </div>
    </div>
}

const GroupTask: React.FC<{ tasks: ITaskService[] }> = ({ tasks }) => {
    const [, set] = useEditOp(state => state.site);

    const handleChange = useCallback((value: ITaskService, index: number) => set(({ operation }) => {
        if (operation) {
            const tasks = cloneObj(operation.tasks || []);
            tasks[index] = value;
            return { operation: { ...operation, tasks }, isCalculate: true }
        }
        return {}
    }), [set])

    const handleDelete = useCallback((index: number) => set(({ operation }) => {
        if (operation) {
            const tasks = cloneObj(operation.tasks || []);
            tasks.splice(index, 1)
            return { operation: { ...operation, tasks } }
        }
        return {}
    }), [set]);

    const group = useMemo(() => {
        return (tasks as ITaskService[]).reduce((rs: {
            [id: string]: { name: string, tasks: { data: ITaskService, index: number }[] }
        }, data, index) => {
            const { location_id, location_name } = data;
            if (!rs[location_id])
                rs[location_id] = { name: location_name, tasks: [] };

            rs[location_id].tasks.push({ data, index });
            return rs;
        }, {})
    }, [tasks]);

    return <>
        {Object.keys(group).map(key => {
            return <React.Fragment key={key}>
                <Title id={key} name={group[key].name} count={group[key].tasks.length} />
                {group[key].tasks.map(({ data, index }) => <Task
                    key={data.group_id}
                    data={data}
                    index={index}
                    onChange={value => handleChange({ ...data, ...value }, index)}
                    onDelete={() => handleDelete(index)}
                />)}
            </React.Fragment>
        })}
    </>;
};

export default GroupTask;
